import { Component } from 'opus-angular-seed-core';

/**
 * Autocomplete component that uses HTTP to query results
 *
 * @var string valueAttribute attribute name to use to populate ngModel variable
 * @var string labelAttribute attribute name to show to user when row is selected
 * @var object|array selectedItem Selected item
 * @var mixed ngModel variable that holds the value of selectedItem[valueAttribute]
 * @var boolean ngDisabled if true, input is disabled and readonly
 * @var string placeholder message to show when input is empty
 * @var query callback to function that returns filtered results, callback can return promise
 */
@Component({
    bindings: {
        ngModel: '=',
        ngDisabled: '=',
        placeholder: '=',
        labelAttribute: '=',
        valueAttribute: '=',
        selectedItem: '=',
        query: '&',
        class: '@'
    },
    template: `
        <input
            type="text"
            class="form-control"
            ng-model="vm.selectedItem"
            ng-disabled="vm.ngDisabled"
            ng-readonly="vm.ngDisabled"
            placeholder="{{ vm.placeholder }}"
            typeahead-on-select="vm.updateNgModel($item, $model, $label, $event)"
            uib-typeahead="item as item[vm.labelAttribute] for item in vm.query({ input: $viewValue })"
        >
    `
})
export default class {
    constructor ($scope, lodash) {
        this.$scope = $scope;
        this.lodash = lodash;
    }

    $onInit () {
        this.$scope.$watch('vm.selectedItem', (newValue) => {
            if (newValue === '') {
                this.updateNgModel();
            }
        });
    }

    updateNgModel (item = null) {
        this.ngModel = this.valueAttribute ? this.lodash.get(item, this.valueAttribute, null) : item;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/autocomplete/index.js